import RestartIcon from '@mui/icons-material/RestartAlt'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import { FullSizeCenteredFlexBox } from 'components/styled'
import resetApp from 'utils/reset-app'

function AppErrorBoundaryFallback() {
  return (
    <Box height={400}>
      <FullSizeCenteredFlexBox>
        <Paper sx={{ p: 5 }} role='alert'>
          <Typography variant='h5' component='h3'>
            Unable to load the app
          </Typography>
          <Typography sx={{ mt: 2 }}>Please reload to try again.</Typography>
          <Button startIcon={<RestartIcon />} sx={{ mt: 3 }} variant='outlined' onClick={resetApp}>
            Reload
          </Button>
        </Paper>
      </FullSizeCenteredFlexBox>
    </Box>
  )
}

export default AppErrorBoundaryFallback
